export const toDate = (value) => new Date(value.replace(" ", "T"));

export const dateKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const militaryTime = (date) =>
  `${String(date.getHours()).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}`;

export const clockTime = (date) =>
  `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

export const dayLabel = (key) =>
  new Date(`${key}T00:00:00`).toLocaleDateString(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short"
  });

export const formatDateTime = (value) =>
  toDate(value).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });

export const toInputValue = (value) => value.replace(" ", "T").slice(0, 16);

// m:ss for a count of seconds. Null/undefined → "" (blank cells); negatives clamp
// to 0 (countdown overrun). One shared formatter for the stopwatch, member record,
// and the workout player.
export const mmss = (seconds) => {
  if (seconds === null || seconds === undefined || seconds === "") return "";
  const s = Math.max(0, Math.floor(Number(seconds)));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

export const durationLabel = (minutes) => {
  const total = Number(minutes);
  if (!total || total <= 0) return null;
  if (total < 60) return `${total}m`;
  if (total % 60 === 0) return `${total / 60}h`;
  return `${Math.floor(total / 60)}h${String(total % 60).padStart(2, "0")}`;
};

export const EVENT_TYPE_LABELS = { PT: "Conditioning", MOCK_TEST: "Assessment", OFFICIAL_TEST: "Official Test", OTHER: "Event" };

// Official PT tests are one of two standard AF assessments; the organizer picks
// the title and members get the mandatory prep reminder auto-filled into notes.
export const OFFICIAL_TEST_TITLES = ["2 Mile Run", "HAMR"];
export const OFFICIAL_TEST_NOTES = "Air Force PT Uniform is required to take this test. Please complete your medical screener from MyFitness and bring the print out for this test. Also print a official score sheet.";
